import {
	countryWithProvince,
	initCountryAndNationality,
	updateProvinceState,
} from "../../../js/utils/helper/forms";

const selectField = (baseId) =>
	document.querySelector(`[data-field-id="${baseId}"]`) ||
	document.querySelector(`#${baseId}`);

const country = selectField("edit-country");
const province = selectField("edit-province");
const nationality = selectField("edit-nationality");

if (country && province && nationality) {
	initCountryAndNationality();

	country.addEventListener("change", (event) => {
		const countryCode = event.target.value;
		const countryHasProvince = countryWithProvince.includes(countryCode);
		updateProvinceState(countryHasProvince, province);
	});
}
